import {apiRegister} from '../../common/api'
import {isArray, sPlain, forEach, isPlain} from '../../utils/base'
import { ERR_DATA_NOT_LIST, ERR_REP_NOT_PLAIN } from '../../const/index'

/**
 * 声明接口：first.share.guide
 * 检测引导分享得时间
 * https://splat-dev.pydp888.com/home/project/service/?pid=6&sid=3&surl=/show/&protoId=160
 */
export const checkShareGuide = apiRegister('checkShareGuide', {
    protoId: 169,
    path : '/award/updown2016/checkshareguide/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 声明接口：tell.share.guide
 * 第一次分享、记录 
 */
export const firstShareGuide = apiRegister('firstShareGuide', {
    protoId: 168,
    path : '/award/updown2016/shareguide/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){
        return R
    }
}).send

/**
 * 声明接口：award.share.forCoin
 * 微信分享策成功金币分享
 * @param scene	string	（可选）分享场景
 */
export const shareForCoin = apiRegister('shareForCoin', {
    protoId: 160,
    path : '/award/updown2016/shareforcoin/',
    checkResult: function(R) {
        return 0
    },
    formatResult (R){
        return R
    }
}).send
